import { createAsyncThunk } from "@reduxjs/toolkit";
import { AssignClaim, claimStatusChange, getAssignedClaimList } from "../service";
import { getStorage } from "../../../../utilities/browserStorage";
import { setNotification } from "./MyWorkSlice";
import i18n from "../../../../utilities/i18n";


export const getMyWorkList = createAsyncThunk(
    'mywork/getMyWorkList',
    async (params, { rejectWithValue }) => {
        try {
            const errorMsg = {
                "user_not_exists_in_this_practice" : i18n.t("my_work.api_error.Asso_user_mapping_not_exist")
            }

            const practiceId = getStorage('practice');

            // If a query was passed in the dispatch, use it. 
            // Otherwise, fall back to just the practice ID.
            const queryString = params?.query || `practice_id=${practiceId}`;

            const response = await getAssignedClaimList(queryString);

            if (response.status === 400) {
                return rejectWithValue({message: errorMsg[response.data.message] || "An error occurred while assigning the claim."});
            }

            if (response.status === 200 || response.status === 201) {
                return response.data;
            }


        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to fetch mywork");
        }
    }
);

export const assignTasktoUser = createAsyncThunk(
    "mywork/assignTasktoUser",
    async (payload, { rejectWithValue , dispatch}) => {
        try {

            const errMessages = {
                "required_fields_missing": i18n.t("my_work.api_error.required_fields_missing"),
                "Error message": i18n.t("my_work.api_error.something_went_wrong"),
                "claim_already_exists_with_status_in_progress_for_the_user": i18n.t("my_work.api_error.claim_exist"),
                "invalid_claim_limit": i18n.t("my_work.api_error.invalid_data"),
                "user_not_exists_in_this_practice": i18n.t("my_work.api_error.user_not_exist"),
                "invalid_practice": i18n.t("my_work.api_error.invalid_practice"),
                "invalid_user": i18n.t("my_work.api_error.invalid_user"),
                "claim_already_exists_with_status_in_progress_or_todo_for_the_user": i18n.t("my_work.api_error.claim_already_exists_with_status_in_progress_or_todo_for_the_user"),
            }

            if (!payload) return rejectWithValue("No practice ID found");
            const response = await AssignClaim(payload);

            if (response.status === 200 || response.status ===201) {
                const { assigned_count,results } = response.data;

                const message = assigned_count > 0
                    ? `Successfully assigned ${assigned_count} claims.`
                    : "No new claims were available for assignment.";

                dispatch(setNotification({ show: true, type: 'success', message: message}));
                return {data: results, assigned_count: assigned_count};
            }
            if (response.status === 400) {

                return rejectWithValue({message: errMessages[response.data.message] || "An error occurred while assigning the claim."});
            }

            if (response.status === 500) {

            return rejectWithValue({message: errMessages[response.data.message] || "An error occurred while assigning the claim."});

            }

            return rejectWithValue({message:"An error occurred while assigning the claim."});
        } catch (error) {
            return rejectWithValue({message: "Something went wrong.",});
        }
    }
);


export const ClaimStatusChange = createAsyncThunk(
    "mywork/ClaimStatusChange",
    async (payload, { rejectWithValue }) => {
        let { id, custom_claim_id } = payload;
        try {
            const errorMessage = {
                "invalid_claim_stage": i18n.t("my_work.api_error.invalid_claim_stage"),
                "required_fields_missing": i18n.t("my_work.api_error.required_fields_missing"),
                "invalid_user": i18n.t("my_work.api_error.invalid_user"),
                "can_not_update_status_to_complete_claim_status_either_in_todo_or_completed": i18n.t("my_work.api_error.can_not_update_status_to_complete_claim_status_either_in_todo_or_completed"),
                "claim_already_assigned_to_another_user": i18n.t("my_work.api_error.claim_already_assigned_to_another_user"),
            };
            let req = {
                claim_id: id,
            }
            const response = await claimStatusChange(req);
            if (response.status === 200) {
                return { data: response.data, id: custom_claim_id};
            }
            if (response.status === 400) {
                return rejectWithValue({ message: errorMessage[response.data.message] || i18n.t("errorMessages.commonError") });
            }
            return rejectWithValue({ message: i18n.t("errorMessages.commonError") });
        } catch (error) {
            return rejectWithValue(error || i18n.t("errorMessages.commonError"));
        }
    }
);